import * as yup from "yup";

export const EvaluationSchema = yup.object({
  interviewer: yup.string().required("Interviewer name is required"),
  remarks: yup.string().required("Remarks can't be empty"),
  sanctionAmount: yup
    .number()
    .required("Sanction amount is required")
    .when("decision", {
      is: (decision: string) => decision !== "rejected",
      then: (schema) => schema.min(1, "Amount must be greater than 0"),
      otherwise: (schema) => schema.oneOf([0], "Amount must be 0 for rejection"),
    }),
  decision: yup.string().required("Please select a final decision"),
  coordinator: yup.string().required("Coordinator name is required"),
});
